import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { AuthTypeComponent } from '../auth-type.shared.component';

@Component({
    selector: 'shared-auth-for-partial-member-password',
    templateUrl: './auth-for-partial-member-password.shared.component.html',
    styleUrls: ['./auth-for-partial-member-password.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthForPartialMemberPasswordComponent extends AuthTypeComponent implements OnInit {
    @Input() public memberId: number;

    public accountLogin$: Observable<string>;

    constructor(
        public controllers: Controllers,
    ) {
        super(controllers);
    }

    ngOnInit(): void {
        this.accountLogin$ = this.controllers.members.getAccountLogin$();
    }
}
